// source: xcommon/nxExtenManage.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var xcommon_common_pb = require('../xcommon/common_pb.js');
goog.object.extend(proto, xcommon_common_pb);
var xcommon_dialer_pb = require('../xcommon/dialer_pb.js');
goog.object.extend(proto, xcommon_dialer_pb);
goog.exportSymbol('proto.xcommon.AddExtenPhoneReq', null, global);
goog.exportSymbol('proto.xcommon.AssignExtenPhoneReq', null, global);
goog.exportSymbol('proto.xcommon.AssignHistoryReq', null, global);
goog.exportSymbol('proto.xcommon.AssignHistoryResp', null, global);
goog.exportSymbol('proto.xcommon.DelExtenPhoneReq', null, global);
goog.exportSymbol('proto.xcommon.ExtenInfo', null, global);
goog.exportSymbol('proto.xcommon.ExtenListResp', null, global);
goog.exportSymbol('proto.xcommon.LockExtenPhoneReq', null, global);
goog.exportSymbol('proto.xcommon.NxteleInfo', null, global);
goog.exportSymbol('proto.xcommon.NxteleListReq', null, global);
goog.exportSymbol('proto.xcommon.NxteleListResp', null, global);
goog.exportSymbol('proto.xcommon.OperateExtenPhoneReq', null, global);
goog.exportSymbol('proto.xcommon.OperateNxteleReq', null, global);
goog.exportSymbol('proto.xcommon.OperateNxteleResp', null, global);
goog.exportSymbol('proto.xcommon.UnLockExtenPhoneReq', null, global);
goog.exportSymbol('proto.xcommon.UpdateExtenPhoneReq', null, global);
goog.exportSymbol('proto.xcommon.UserAssigned', null, global);
goog.exportSymbol('proto.xcommon.UserAssignedListReq', null, global);
goog.exportSymbol('proto.xcommon.UserAssignedListResp', null, global);
goog.exportSymbol('proto.xcommon.XExtenListReq', null, global);
goog.exportSymbol('proto.xcommon.assignHistory', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DelExtenPhoneReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.DelExtenPhoneReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.DelExtenPhoneReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DelExtenPhoneReq.displayName = 'proto.xcommon.DelExtenPhoneReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AddExtenPhoneReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.AddExtenPhoneReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AddExtenPhoneReq.displayName = 'proto.xcommon.AddExtenPhoneReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UpdateExtenPhoneReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.UpdateExtenPhoneReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UpdateExtenPhoneReq.displayName = 'proto.xcommon.UpdateExtenPhoneReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AssignExtenPhoneReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.AssignExtenPhoneReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AssignExtenPhoneReq.displayName = 'proto.xcommon.AssignExtenPhoneReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.LockExtenPhoneReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.LockExtenPhoneReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.LockExtenPhoneReq.displayName = 'proto.xcommon.LockExtenPhoneReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UnLockExtenPhoneReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.UnLockExtenPhoneReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UnLockExtenPhoneReq.displayName = 'proto.xcommon.UnLockExtenPhoneReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AssignHistoryReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.AssignHistoryReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AssignHistoryReq.displayName = 'proto.xcommon.AssignHistoryReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.assignHistory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.assignHistory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.assignHistory.displayName = 'proto.xcommon.assignHistory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AssignHistoryResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.AssignHistoryResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.AssignHistoryResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AssignHistoryResp.displayName = 'proto.xcommon.AssignHistoryResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UserAssignedListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.UserAssignedListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UserAssignedListReq.displayName = 'proto.xcommon.UserAssignedListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UserAssigned = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.UserAssigned, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UserAssigned.displayName = 'proto.xcommon.UserAssigned';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UserAssignedListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.UserAssignedListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.UserAssignedListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UserAssignedListResp.displayName = 'proto.xcommon.UserAssignedListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.XExtenListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.XExtenListReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.XExtenListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.XExtenListReq.displayName = 'proto.xcommon.XExtenListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ExtenListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ExtenListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ExtenListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ExtenListResp.displayName = 'proto.xcommon.ExtenListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ExtenInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ExtenInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ExtenInfo.displayName = 'proto.xcommon.ExtenInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.NxteleListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.NxteleListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.NxteleListReq.displayName = 'proto.xcommon.NxteleListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.NxteleInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.NxteleInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.NxteleInfo.displayName = 'proto.xcommon.NxteleInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.NxteleListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.NxteleListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.NxteleListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.NxteleListResp.displayName = 'proto.xcommon.NxteleListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OperateNxteleReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.OperateNxteleReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OperateNxteleReq.displayName = 'proto.xcommon.OperateNxteleReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OperateNxteleResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.OperateNxteleResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OperateNxteleResp.displayName = 'proto.xcommon.OperateNxteleResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OperateExtenPhoneReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.OperateExtenPhoneReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.OperateExtenPhoneReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OperateExtenPhoneReq.displayName = 'proto.xcommon.OperateExtenPhoneReq';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.DelExtenPhoneReq.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DelExtenPhoneReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DelExtenPhoneReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DelExtenPhoneReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DelExtenPhoneReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    idList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DelExtenPhoneReq}
 */
proto.xcommon.DelExtenPhoneReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DelExtenPhoneReq;
  return proto.xcommon.DelExtenPhoneReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DelExtenPhoneReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DelExtenPhoneReq}
 */
proto.xcommon.DelExtenPhoneReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addId(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DelExtenPhoneReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DelExtenPhoneReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DelExtenPhoneReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DelExtenPhoneReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getIdList();
  if (f.length > 0) {
    writer.writePackedInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.DelExtenPhoneReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.DelExtenPhoneReq} returns this
*/
proto.xcommon.DelExtenPhoneReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.DelExtenPhoneReq} returns this
 */
proto.xcommon.DelExtenPhoneReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DelExtenPhoneReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated int64 Id = 2;
 * @return {!Array<number>}
 */
proto.xcommon.DelExtenPhoneReq.prototype.getIdList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.xcommon.DelExtenPhoneReq} returns this
 */
proto.xcommon.DelExtenPhoneReq.prototype.setIdList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.xcommon.DelExtenPhoneReq} returns this
 */
proto.xcommon.DelExtenPhoneReq.prototype.addId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.DelExtenPhoneReq} returns this
 */
proto.xcommon.DelExtenPhoneReq.prototype.clearIdList = function() {
  return this.setIdList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AddExtenPhoneReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AddExtenPhoneReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AddExtenPhoneReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AddExtenPhoneReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    supliertype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    nxteleid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    extnumberstart: jspb.Message.getFieldWithDefault(msg, 4, 0),
    extnumberend: jspb.Message.getFieldWithDefault(msg, 5, 0),
    id: jspb.Message.getFieldWithDefault(msg, 6, 0),
    extuser: jspb.Message.getFieldWithDefault(msg, 7, ""),
    extpwd: jspb.Message.getFieldWithDefault(msg, 8, ""),
    extuserstart: jspb.Message.getFieldWithDefault(msg, 9, 0),
    extuserend: jspb.Message.getFieldWithDefault(msg, 10, 0),
    extpwdstart: jspb.Message.getFieldWithDefault(msg, 11, 0),
    extpwdend: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AddExtenPhoneReq}
 */
proto.xcommon.AddExtenPhoneReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AddExtenPhoneReq;
  return proto.xcommon.AddExtenPhoneReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AddExtenPhoneReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AddExtenPhoneReq}
 */
proto.xcommon.AddExtenPhoneReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSupliertype(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNxteleid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExtnumberstart(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExtnumberend(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtuser(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtpwd(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExtuserstart(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExtuserend(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExtpwdstart(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExtpwdend(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AddExtenPhoneReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AddExtenPhoneReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AddExtenPhoneReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AddExtenPhoneReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getSupliertype();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getNxteleid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getExtnumberstart();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getExtnumberend();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getExtuser();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getExtpwd();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getExtuserstart();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getExtuserend();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getExtpwdstart();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getExtpwdend();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.AddExtenPhoneReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.AddExtenPhoneReq} returns this
*/
proto.xcommon.AddExtenPhoneReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.AddExtenPhoneReq} returns this
 */
proto.xcommon.AddExtenPhoneReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.AddExtenPhoneReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 SuplierType = 2;
 * @return {number}
 */
proto.xcommon.AddExtenPhoneReq.prototype.getSupliertype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.AddExtenPhoneReq} returns this
 */
proto.xcommon.AddExtenPhoneReq.prototype.setSupliertype = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 NxteleId = 3;
 * @return {number}
 */
proto.xcommon.AddExtenPhoneReq.prototype.getNxteleid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.AddExtenPhoneReq} returns this
 */
proto.xcommon.AddExtenPhoneReq.prototype.setNxteleid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 ExtNumberStart = 4;
 * @return {number}
 */
proto.xcommon.AddExtenPhoneReq.prototype.getExtnumberstart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.AddExtenPhoneReq} returns this
 */
proto.xcommon.AddExtenPhoneReq.prototype.setExtnumberstart = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 ExtNumberEnd = 5;
 * @return {number}
 */
proto.xcommon.AddExtenPhoneReq.prototype.getExtnumberend = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.AddExtenPhoneReq} returns this
 */
proto.xcommon.AddExtenPhoneReq.prototype.setExtnumberend = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 Id = 6;
 * @return {number}
 */
proto.xcommon.AddExtenPhoneReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.AddExtenPhoneReq} returns this
 */
proto.xcommon.AddExtenPhoneReq.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string ExtUser = 7;
 * @return {string}
 */
proto.xcommon.AddExtenPhoneReq.prototype.getExtuser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.AddExtenPhoneReq} returns this
 */
proto.xcommon.AddExtenPhoneReq.prototype.setExtuser = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string ExtPwd = 8;
 * @return {string}
 */
proto.xcommon.AddExtenPhoneReq.prototype.getExtpwd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.AddExtenPhoneReq} returns this
 */
proto.xcommon.AddExtenPhoneReq.prototype.setExtpwd = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int64 ExtUserStart = 9;
 * @return {number}
 */
proto.xcommon.AddExtenPhoneReq.prototype.getExtuserstart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.AddExtenPhoneReq} returns this
 */
proto.xcommon.AddExtenPhoneReq.prototype.setExtuserstart = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 ExtUserEnd = 10;
 * @return {number}
 */
proto.xcommon.AddExtenPhoneReq.prototype.getExtuserend = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.AddExtenPhoneReq} returns this
 */
proto.xcommon.AddExtenPhoneReq.prototype.setExtuserend = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 ExtPwdStart = 11;
 * @return {number}
 */
proto.xcommon.AddExtenPhoneReq.prototype.getExtpwdstart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.AddExtenPhoneReq} returns this
 */
proto.xcommon.AddExtenPhoneReq.prototype.setExtpwdstart = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 ExtPwdEnd = 12;
 * @return {number}
 */
proto.xcommon.AddExtenPhoneReq.prototype.getExtpwdend = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.AddExtenPhoneReq} returns this
 */
proto.xcommon.AddExtenPhoneReq.prototype.setExtpwdend = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UpdateExtenPhoneReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UpdateExtenPhoneReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UpdateExtenPhoneReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UpdateExtenPhoneReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    supliertype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    nxteleid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    extnumber: jspb.Message.getFieldWithDefault(msg, 4, 0),
    id: jspb.Message.getFieldWithDefault(msg, 5, 0),
    assignid: jspb.Message.getFieldWithDefault(msg, 6, 0),
    assignstatus: jspb.Message.getFieldWithDefault(msg, 7, 0),
    opuid: jspb.Message.getFieldWithDefault(msg, 8, 0),
    extuser: jspb.Message.getFieldWithDefault(msg, 9, ""),
    extpwd: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UpdateExtenPhoneReq}
 */
proto.xcommon.UpdateExtenPhoneReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UpdateExtenPhoneReq;
  return proto.xcommon.UpdateExtenPhoneReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UpdateExtenPhoneReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UpdateExtenPhoneReq}
 */
proto.xcommon.UpdateExtenPhoneReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSupliertype(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNxteleid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExtnumber(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignid(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignstatus(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpuid(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtuser(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtpwd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UpdateExtenPhoneReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UpdateExtenPhoneReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UpdateExtenPhoneReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UpdateExtenPhoneReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getSupliertype();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getNxteleid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getExtnumber();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getAssignid();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAssignstatus();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getOpuid();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getExtuser();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getExtpwd();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.UpdateExtenPhoneReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.UpdateExtenPhoneReq} returns this
*/
proto.xcommon.UpdateExtenPhoneReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UpdateExtenPhoneReq} returns this
 */
proto.xcommon.UpdateExtenPhoneReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UpdateExtenPhoneReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 SuplierType = 2;
 * @return {number}
 */
proto.xcommon.UpdateExtenPhoneReq.prototype.getSupliertype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UpdateExtenPhoneReq} returns this
 */
proto.xcommon.UpdateExtenPhoneReq.prototype.setSupliertype = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 NxteleId = 3;
 * @return {number}
 */
proto.xcommon.UpdateExtenPhoneReq.prototype.getNxteleid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UpdateExtenPhoneReq} returns this
 */
proto.xcommon.UpdateExtenPhoneReq.prototype.setNxteleid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 ExtNumber = 4;
 * @return {number}
 */
proto.xcommon.UpdateExtenPhoneReq.prototype.getExtnumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UpdateExtenPhoneReq} returns this
 */
proto.xcommon.UpdateExtenPhoneReq.prototype.setExtnumber = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 Id = 5;
 * @return {number}
 */
proto.xcommon.UpdateExtenPhoneReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UpdateExtenPhoneReq} returns this
 */
proto.xcommon.UpdateExtenPhoneReq.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 AssignId = 6;
 * @return {number}
 */
proto.xcommon.UpdateExtenPhoneReq.prototype.getAssignid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UpdateExtenPhoneReq} returns this
 */
proto.xcommon.UpdateExtenPhoneReq.prototype.setAssignid = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 AssignStatus = 7;
 * @return {number}
 */
proto.xcommon.UpdateExtenPhoneReq.prototype.getAssignstatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UpdateExtenPhoneReq} returns this
 */
proto.xcommon.UpdateExtenPhoneReq.prototype.setAssignstatus = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 OpUid = 8;
 * @return {number}
 */
proto.xcommon.UpdateExtenPhoneReq.prototype.getOpuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UpdateExtenPhoneReq} returns this
 */
proto.xcommon.UpdateExtenPhoneReq.prototype.setOpuid = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string ExtUser = 9;
 * @return {string}
 */
proto.xcommon.UpdateExtenPhoneReq.prototype.getExtuser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UpdateExtenPhoneReq} returns this
 */
proto.xcommon.UpdateExtenPhoneReq.prototype.setExtuser = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string ExtPwd = 10;
 * @return {string}
 */
proto.xcommon.UpdateExtenPhoneReq.prototype.getExtpwd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UpdateExtenPhoneReq} returns this
 */
proto.xcommon.UpdateExtenPhoneReq.prototype.setExtpwd = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AssignExtenPhoneReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AssignExtenPhoneReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AssignExtenPhoneReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AssignExtenPhoneReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    extnumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    assignid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    opuid: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AssignExtenPhoneReq}
 */
proto.xcommon.AssignExtenPhoneReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AssignExtenPhoneReq;
  return proto.xcommon.AssignExtenPhoneReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AssignExtenPhoneReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AssignExtenPhoneReq}
 */
proto.xcommon.AssignExtenPhoneReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExtnumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AssignExtenPhoneReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AssignExtenPhoneReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AssignExtenPhoneReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AssignExtenPhoneReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getExtnumber();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAssignid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getOpuid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.AssignExtenPhoneReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.AssignExtenPhoneReq} returns this
*/
proto.xcommon.AssignExtenPhoneReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.AssignExtenPhoneReq} returns this
 */
proto.xcommon.AssignExtenPhoneReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.AssignExtenPhoneReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 ExtNumber = 2;
 * @return {number}
 */
proto.xcommon.AssignExtenPhoneReq.prototype.getExtnumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.AssignExtenPhoneReq} returns this
 */
proto.xcommon.AssignExtenPhoneReq.prototype.setExtnumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 AssignId = 3;
 * @return {number}
 */
proto.xcommon.AssignExtenPhoneReq.prototype.getAssignid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.AssignExtenPhoneReq} returns this
 */
proto.xcommon.AssignExtenPhoneReq.prototype.setAssignid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 OpUid = 4;
 * @return {number}
 */
proto.xcommon.AssignExtenPhoneReq.prototype.getOpuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.AssignExtenPhoneReq} returns this
 */
proto.xcommon.AssignExtenPhoneReq.prototype.setOpuid = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.LockExtenPhoneReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.LockExtenPhoneReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.LockExtenPhoneReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LockExtenPhoneReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    assignid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    supplier: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.LockExtenPhoneReq}
 */
proto.xcommon.LockExtenPhoneReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.LockExtenPhoneReq;
  return proto.xcommon.LockExtenPhoneReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.LockExtenPhoneReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.LockExtenPhoneReq}
 */
proto.xcommon.LockExtenPhoneReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSupplier(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.LockExtenPhoneReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.LockExtenPhoneReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.LockExtenPhoneReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LockExtenPhoneReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getAssignid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getSupplier();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.LockExtenPhoneReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.LockExtenPhoneReq} returns this
*/
proto.xcommon.LockExtenPhoneReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.LockExtenPhoneReq} returns this
 */
proto.xcommon.LockExtenPhoneReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.LockExtenPhoneReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 AssignId = 2;
 * @return {number}
 */
proto.xcommon.LockExtenPhoneReq.prototype.getAssignid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.LockExtenPhoneReq} returns this
 */
proto.xcommon.LockExtenPhoneReq.prototype.setAssignid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 Supplier = 3;
 * @return {number}
 */
proto.xcommon.LockExtenPhoneReq.prototype.getSupplier = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.LockExtenPhoneReq} returns this
 */
proto.xcommon.LockExtenPhoneReq.prototype.setSupplier = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UnLockExtenPhoneReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UnLockExtenPhoneReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UnLockExtenPhoneReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UnLockExtenPhoneReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    assignid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    supplier: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UnLockExtenPhoneReq}
 */
proto.xcommon.UnLockExtenPhoneReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UnLockExtenPhoneReq;
  return proto.xcommon.UnLockExtenPhoneReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UnLockExtenPhoneReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UnLockExtenPhoneReq}
 */
proto.xcommon.UnLockExtenPhoneReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSupplier(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UnLockExtenPhoneReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UnLockExtenPhoneReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UnLockExtenPhoneReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UnLockExtenPhoneReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getAssignid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getSupplier();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.UnLockExtenPhoneReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.UnLockExtenPhoneReq} returns this
*/
proto.xcommon.UnLockExtenPhoneReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UnLockExtenPhoneReq} returns this
 */
proto.xcommon.UnLockExtenPhoneReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UnLockExtenPhoneReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 AssignId = 2;
 * @return {number}
 */
proto.xcommon.UnLockExtenPhoneReq.prototype.getAssignid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UnLockExtenPhoneReq} returns this
 */
proto.xcommon.UnLockExtenPhoneReq.prototype.setAssignid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 Supplier = 3;
 * @return {number}
 */
proto.xcommon.UnLockExtenPhoneReq.prototype.getSupplier = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UnLockExtenPhoneReq} returns this
 */
proto.xcommon.UnLockExtenPhoneReq.prototype.setSupplier = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AssignHistoryReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AssignHistoryReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AssignHistoryReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AssignHistoryReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    extnumber: jspb.Message.getFieldWithDefault(msg, 3, ""),
    supliertype: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AssignHistoryReq}
 */
proto.xcommon.AssignHistoryReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AssignHistoryReq;
  return proto.xcommon.AssignHistoryReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AssignHistoryReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AssignHistoryReq}
 */
proto.xcommon.AssignHistoryReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtnumber(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSupliertype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AssignHistoryReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AssignHistoryReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AssignHistoryReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AssignHistoryReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getExtnumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSupliertype();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.AssignHistoryReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.AssignHistoryReq} returns this
*/
proto.xcommon.AssignHistoryReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.AssignHistoryReq} returns this
 */
proto.xcommon.AssignHistoryReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.AssignHistoryReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.AssignHistoryReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.xcommon.AssignHistoryReq} returns this
*/
proto.xcommon.AssignHistoryReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.AssignHistoryReq} returns this
 */
proto.xcommon.AssignHistoryReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.AssignHistoryReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string ExtNumber = 3;
 * @return {string}
 */
proto.xcommon.AssignHistoryReq.prototype.getExtnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.AssignHistoryReq} returns this
 */
proto.xcommon.AssignHistoryReq.prototype.setExtnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 SuplierType = 4;
 * @return {number}
 */
proto.xcommon.AssignHistoryReq.prototype.getSupliertype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.AssignHistoryReq} returns this
 */
proto.xcommon.AssignHistoryReq.prototype.setSupliertype = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.assignHistory.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.assignHistory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.assignHistory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.assignHistory.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    extnumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    opuid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    opuname: jspb.Message.getFieldWithDefault(msg, 4, ""),
    assignid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    assignname: jspb.Message.getFieldWithDefault(msg, 6, ""),
    assigntime: jspb.Message.getFieldWithDefault(msg, 7, 0),
    cancletime: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.assignHistory}
 */
proto.xcommon.assignHistory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.assignHistory;
  return proto.xcommon.assignHistory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.assignHistory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.assignHistory}
 */
proto.xcommon.assignHistory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExtnumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpuid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpuname(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssignname(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssigntime(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCancletime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.assignHistory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.assignHistory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.assignHistory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.assignHistory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getExtnumber();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getOpuid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getOpuname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAssignid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getAssignname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAssigntime();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getCancletime();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.assignHistory.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.assignHistory} returns this
 */
proto.xcommon.assignHistory.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 ExtNumber = 2;
 * @return {number}
 */
proto.xcommon.assignHistory.prototype.getExtnumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.assignHistory} returns this
 */
proto.xcommon.assignHistory.prototype.setExtnumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 OpUid = 3;
 * @return {number}
 */
proto.xcommon.assignHistory.prototype.getOpuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.assignHistory} returns this
 */
proto.xcommon.assignHistory.prototype.setOpuid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string OpUname = 4;
 * @return {string}
 */
proto.xcommon.assignHistory.prototype.getOpuname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.assignHistory} returns this
 */
proto.xcommon.assignHistory.prototype.setOpuname = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 AssignId = 5;
 * @return {number}
 */
proto.xcommon.assignHistory.prototype.getAssignid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.assignHistory} returns this
 */
proto.xcommon.assignHistory.prototype.setAssignid = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string AssignName = 6;
 * @return {string}
 */
proto.xcommon.assignHistory.prototype.getAssignname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.assignHistory} returns this
 */
proto.xcommon.assignHistory.prototype.setAssignname = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 AssignTime = 7;
 * @return {number}
 */
proto.xcommon.assignHistory.prototype.getAssigntime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.assignHistory} returns this
 */
proto.xcommon.assignHistory.prototype.setAssigntime = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 CancleTime = 8;
 * @return {number}
 */
proto.xcommon.assignHistory.prototype.getCancletime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.assignHistory} returns this
 */
proto.xcommon.assignHistory.prototype.setCancletime = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.AssignHistoryResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AssignHistoryResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AssignHistoryResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AssignHistoryResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AssignHistoryResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    historylistList: jspb.Message.toObjectList(msg.getHistorylistList(),
    proto.xcommon.assignHistory.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AssignHistoryResp}
 */
proto.xcommon.AssignHistoryResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AssignHistoryResp;
  return proto.xcommon.AssignHistoryResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AssignHistoryResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AssignHistoryResp}
 */
proto.xcommon.AssignHistoryResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.assignHistory;
      reader.readMessage(value,proto.xcommon.assignHistory.deserializeBinaryFromReader);
      msg.addHistorylist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AssignHistoryResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AssignHistoryResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AssignHistoryResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AssignHistoryResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getHistorylistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.assignHistory.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.AssignHistoryResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.AssignHistoryResp} returns this
*/
proto.xcommon.AssignHistoryResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.AssignHistoryResp} returns this
 */
proto.xcommon.AssignHistoryResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.AssignHistoryResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.AssignHistoryResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/**
 * @param {?proto.xcommon.PageOut|undefined} value
 * @return {!proto.xcommon.AssignHistoryResp} returns this
*/
proto.xcommon.AssignHistoryResp.prototype.setPageout = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.AssignHistoryResp} returns this
 */
proto.xcommon.AssignHistoryResp.prototype.clearPageout = function() {
  return this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.AssignHistoryResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated assignHistory historyList = 3;
 * @return {!Array<!proto.xcommon.assignHistory>}
 */
proto.xcommon.AssignHistoryResp.prototype.getHistorylistList = function() {
  return /** @type{!Array<!proto.xcommon.assignHistory>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.assignHistory, 3));
};


/**
 * @param {!Array<!proto.xcommon.assignHistory>} value
 * @return {!proto.xcommon.AssignHistoryResp} returns this
*/
proto.xcommon.AssignHistoryResp.prototype.setHistorylistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.assignHistory=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.assignHistory}
 */
proto.xcommon.AssignHistoryResp.prototype.addHistorylist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.assignHistory, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.AssignHistoryResp} returns this
 */
proto.xcommon.AssignHistoryResp.prototype.clearHistorylistList = function() {
  return this.setHistorylistList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UserAssignedListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UserAssignedListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UserAssignedListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UserAssignedListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    username: jspb.Message.getFieldWithDefault(msg, 3, ""),
    email: jspb.Message.getFieldWithDefault(msg, 4, ""),
    usergroup: jspb.Message.getFieldWithDefault(msg, 5, ""),
    supplier: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UserAssignedListReq}
 */
proto.xcommon.UserAssignedListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UserAssignedListReq;
  return proto.xcommon.UserAssignedListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UserAssignedListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UserAssignedListReq}
 */
proto.xcommon.UserAssignedListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsergroup(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSupplier(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UserAssignedListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UserAssignedListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UserAssignedListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UserAssignedListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUsergroup();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSupplier();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.UserAssignedListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.UserAssignedListReq} returns this
*/
proto.xcommon.UserAssignedListReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UserAssignedListReq} returns this
 */
proto.xcommon.UserAssignedListReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UserAssignedListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.UserAssignedListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.xcommon.UserAssignedListReq} returns this
*/
proto.xcommon.UserAssignedListReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UserAssignedListReq} returns this
 */
proto.xcommon.UserAssignedListReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UserAssignedListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string UserName = 3;
 * @return {string}
 */
proto.xcommon.UserAssignedListReq.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UserAssignedListReq} returns this
 */
proto.xcommon.UserAssignedListReq.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Email = 4;
 * @return {string}
 */
proto.xcommon.UserAssignedListReq.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UserAssignedListReq} returns this
 */
proto.xcommon.UserAssignedListReq.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string UserGroup = 5;
 * @return {string}
 */
proto.xcommon.UserAssignedListReq.prototype.getUsergroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UserAssignedListReq} returns this
 */
proto.xcommon.UserAssignedListReq.prototype.setUsergroup = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 Supplier = 6;
 * @return {number}
 */
proto.xcommon.UserAssignedListReq.prototype.getSupplier = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UserAssignedListReq} returns this
 */
proto.xcommon.UserAssignedListReq.prototype.setSupplier = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UserAssigned.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UserAssigned.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UserAssigned} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UserAssigned.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    email: jspb.Message.getFieldWithDefault(msg, 3, ""),
    usergroup: jspb.Message.getFieldWithDefault(msg, 4, ""),
    isinvalide: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    isassign: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UserAssigned}
 */
proto.xcommon.UserAssigned.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UserAssigned;
  return proto.xcommon.UserAssigned.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UserAssigned} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UserAssigned}
 */
proto.xcommon.UserAssigned.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsergroup(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsinvalide(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsassign(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UserAssigned.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UserAssigned.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UserAssigned} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UserAssigned.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUsergroup();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIsinvalide();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getIsassign();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.UserAssigned.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UserAssigned} returns this
 */
proto.xcommon.UserAssigned.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.xcommon.UserAssigned.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UserAssigned} returns this
 */
proto.xcommon.UserAssigned.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Email = 3;
 * @return {string}
 */
proto.xcommon.UserAssigned.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UserAssigned} returns this
 */
proto.xcommon.UserAssigned.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string UserGroup = 4;
 * @return {string}
 */
proto.xcommon.UserAssigned.prototype.getUsergroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UserAssigned} returns this
 */
proto.xcommon.UserAssigned.prototype.setUsergroup = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool IsInvalide = 5;
 * @return {boolean}
 */
proto.xcommon.UserAssigned.prototype.getIsinvalide = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.xcommon.UserAssigned} returns this
 */
proto.xcommon.UserAssigned.prototype.setIsinvalide = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool IsAssign = 6;
 * @return {boolean}
 */
proto.xcommon.UserAssigned.prototype.getIsassign = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.xcommon.UserAssigned} returns this
 */
proto.xcommon.UserAssigned.prototype.setIsassign = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.UserAssignedListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UserAssignedListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UserAssignedListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UserAssignedListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UserAssignedListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    userassignedlistList: jspb.Message.toObjectList(msg.getUserassignedlistList(),
    proto.xcommon.UserAssigned.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UserAssignedListResp}
 */
proto.xcommon.UserAssignedListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UserAssignedListResp;
  return proto.xcommon.UserAssignedListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UserAssignedListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UserAssignedListResp}
 */
proto.xcommon.UserAssignedListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.UserAssigned;
      reader.readMessage(value,proto.xcommon.UserAssigned.deserializeBinaryFromReader);
      msg.addUserassignedlist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UserAssignedListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UserAssignedListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UserAssignedListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UserAssignedListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getUserassignedlistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.UserAssigned.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.UserAssignedListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.UserAssignedListResp} returns this
*/
proto.xcommon.UserAssignedListResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UserAssignedListResp} returns this
 */
proto.xcommon.UserAssignedListResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UserAssignedListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.UserAssignedListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/**
 * @param {?proto.xcommon.PageOut|undefined} value
 * @return {!proto.xcommon.UserAssignedListResp} returns this
*/
proto.xcommon.UserAssignedListResp.prototype.setPageout = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UserAssignedListResp} returns this
 */
proto.xcommon.UserAssignedListResp.prototype.clearPageout = function() {
  return this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UserAssignedListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated UserAssigned userAssignedList = 3;
 * @return {!Array<!proto.xcommon.UserAssigned>}
 */
proto.xcommon.UserAssignedListResp.prototype.getUserassignedlistList = function() {
  return /** @type{!Array<!proto.xcommon.UserAssigned>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.UserAssigned, 3));
};


/**
 * @param {!Array<!proto.xcommon.UserAssigned>} value
 * @return {!proto.xcommon.UserAssignedListResp} returns this
*/
proto.xcommon.UserAssignedListResp.prototype.setUserassignedlistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.UserAssigned=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.UserAssigned}
 */
proto.xcommon.UserAssignedListResp.prototype.addUserassignedlist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.UserAssigned, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.UserAssignedListResp} returns this
 */
proto.xcommon.UserAssignedListResp.prototype.clearUserassignedlistList = function() {
  return this.setUserassignedlistList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.XExtenListReq.repeatedFields_ = [11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.XExtenListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.XExtenListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.XExtenListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.XExtenListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    extnumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
    username: jspb.Message.getFieldWithDefault(msg, 4, ""),
    supplier: jspb.Message.getFieldWithDefault(msg, 5, 0),
    assignstatus: jspb.Message.getFieldWithDefault(msg, 6, 0),
    addstarttime: jspb.Message.getFieldWithDefault(msg, 7, 0),
    addendtime: jspb.Message.getFieldWithDefault(msg, 8, 0),
    searchstart: jspb.Message.getFieldWithDefault(msg, 9, 0),
    searchend: jspb.Message.getFieldWithDefault(msg, 10, 0),
    assignidsList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
    extuser: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.XExtenListReq}
 */
proto.xcommon.XExtenListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.XExtenListReq;
  return proto.xcommon.XExtenListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.XExtenListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.XExtenListReq}
 */
proto.xcommon.XExtenListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExtnumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSupplier(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignstatus(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAddstarttime(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAddendtime(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSearchstart(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSearchend(value);
      break;
    case 11:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addAssignids(values[i]);
      }
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtuser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.XExtenListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.XExtenListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.XExtenListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.XExtenListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getExtnumber();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSupplier();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getAssignstatus();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAddstarttime();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getAddendtime();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getSearchstart();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getSearchend();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getAssignidsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      11,
      f
    );
  }
  f = message.getExtuser();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.XExtenListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.XExtenListReq} returns this
*/
proto.xcommon.XExtenListReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.XExtenListReq} returns this
 */
proto.xcommon.XExtenListReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.XExtenListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.XExtenListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.xcommon.XExtenListReq} returns this
*/
proto.xcommon.XExtenListReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.XExtenListReq} returns this
 */
proto.xcommon.XExtenListReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.XExtenListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 ExtNumber = 3;
 * @return {number}
 */
proto.xcommon.XExtenListReq.prototype.getExtnumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.XExtenListReq} returns this
 */
proto.xcommon.XExtenListReq.prototype.setExtnumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string UserName = 4;
 * @return {string}
 */
proto.xcommon.XExtenListReq.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.XExtenListReq} returns this
 */
proto.xcommon.XExtenListReq.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 Supplier = 5;
 * @return {number}
 */
proto.xcommon.XExtenListReq.prototype.getSupplier = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.XExtenListReq} returns this
 */
proto.xcommon.XExtenListReq.prototype.setSupplier = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 AssignStatus = 6;
 * @return {number}
 */
proto.xcommon.XExtenListReq.prototype.getAssignstatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.XExtenListReq} returns this
 */
proto.xcommon.XExtenListReq.prototype.setAssignstatus = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 AddStartTime = 7;
 * @return {number}
 */
proto.xcommon.XExtenListReq.prototype.getAddstarttime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.XExtenListReq} returns this
 */
proto.xcommon.XExtenListReq.prototype.setAddstarttime = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 AddEndTime = 8;
 * @return {number}
 */
proto.xcommon.XExtenListReq.prototype.getAddendtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.XExtenListReq} returns this
 */
proto.xcommon.XExtenListReq.prototype.setAddendtime = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 SearchStart = 9;
 * @return {number}
 */
proto.xcommon.XExtenListReq.prototype.getSearchstart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.XExtenListReq} returns this
 */
proto.xcommon.XExtenListReq.prototype.setSearchstart = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 SearchEnd = 10;
 * @return {number}
 */
proto.xcommon.XExtenListReq.prototype.getSearchend = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.XExtenListReq} returns this
 */
proto.xcommon.XExtenListReq.prototype.setSearchend = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * repeated int64 AssignIds = 11;
 * @return {!Array<number>}
 */
proto.xcommon.XExtenListReq.prototype.getAssignidsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.xcommon.XExtenListReq} returns this
 */
proto.xcommon.XExtenListReq.prototype.setAssignidsList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.xcommon.XExtenListReq} returns this
 */
proto.xcommon.XExtenListReq.prototype.addAssignids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.XExtenListReq} returns this
 */
proto.xcommon.XExtenListReq.prototype.clearAssignidsList = function() {
  return this.setAssignidsList([]);
};


/**
 * optional string ExtUser = 12;
 * @return {string}
 */
proto.xcommon.XExtenListReq.prototype.getExtuser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.XExtenListReq} returns this
 */
proto.xcommon.XExtenListReq.prototype.setExtuser = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ExtenListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ExtenListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ExtenListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ExtenListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ExtenListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    extenlistList: jspb.Message.toObjectList(msg.getExtenlistList(),
    proto.xcommon.ExtenInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ExtenListResp}
 */
proto.xcommon.ExtenListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ExtenListResp;
  return proto.xcommon.ExtenListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ExtenListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ExtenListResp}
 */
proto.xcommon.ExtenListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.ExtenInfo;
      reader.readMessage(value,proto.xcommon.ExtenInfo.deserializeBinaryFromReader);
      msg.addExtenlist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ExtenListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ExtenListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ExtenListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ExtenListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getExtenlistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.ExtenInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ExtenListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.ExtenListResp} returns this
*/
proto.xcommon.ExtenListResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.ExtenListResp} returns this
 */
proto.xcommon.ExtenListResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ExtenListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.ExtenListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/**
 * @param {?proto.xcommon.PageOut|undefined} value
 * @return {!proto.xcommon.ExtenListResp} returns this
*/
proto.xcommon.ExtenListResp.prototype.setPageout = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.ExtenListResp} returns this
 */
proto.xcommon.ExtenListResp.prototype.clearPageout = function() {
  return this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ExtenListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated ExtenInfo ExtenList = 3;
 * @return {!Array<!proto.xcommon.ExtenInfo>}
 */
proto.xcommon.ExtenListResp.prototype.getExtenlistList = function() {
  return /** @type{!Array<!proto.xcommon.ExtenInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.ExtenInfo, 3));
};


/**
 * @param {!Array<!proto.xcommon.ExtenInfo>} value
 * @return {!proto.xcommon.ExtenListResp} returns this
*/
proto.xcommon.ExtenListResp.prototype.setExtenlistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.ExtenInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.ExtenInfo}
 */
proto.xcommon.ExtenListResp.prototype.addExtenlist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.ExtenInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.ExtenListResp} returns this
 */
proto.xcommon.ExtenListResp.prototype.clearExtenlistList = function() {
  return this.setExtenlistList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ExtenInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ExtenInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ExtenInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ExtenInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    username: jspb.Message.getFieldWithDefault(msg, 2, ""),
    userid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    extnumber: jspb.Message.getFieldWithDefault(msg, 4, 0),
    assignstatus: jspb.Message.getFieldWithDefault(msg, 6, 0),
    suptelename: jspb.Message.getFieldWithDefault(msg, 7, ""),
    supplier: jspb.Message.getFieldWithDefault(msg, 8, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 9, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 10, 0),
    voipname: jspb.Message.getFieldWithDefault(msg, 11, ""),
    extuser: jspb.Message.getFieldWithDefault(msg, 12, ""),
    extpwd: jspb.Message.getFieldWithDefault(msg, 13, ""),
    nxteleid: jspb.Message.getFieldWithDefault(msg, 14, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ExtenInfo}
 */
proto.xcommon.ExtenInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ExtenInfo;
  return proto.xcommon.ExtenInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ExtenInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ExtenInfo}
 */
proto.xcommon.ExtenInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExtnumber(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAssignstatus(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSuptelename(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSupplier(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setVoipname(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtuser(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtpwd(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNxteleid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ExtenInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ExtenInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ExtenInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ExtenInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getExtnumber();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getAssignstatus();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getSuptelename();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSupplier();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getVoipname();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getExtuser();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getExtpwd();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getNxteleid();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.ExtenInfo.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ExtenInfo} returns this
 */
proto.xcommon.ExtenInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string UserName = 2;
 * @return {string}
 */
proto.xcommon.ExtenInfo.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ExtenInfo} returns this
 */
proto.xcommon.ExtenInfo.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 UserId = 3;
 * @return {number}
 */
proto.xcommon.ExtenInfo.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ExtenInfo} returns this
 */
proto.xcommon.ExtenInfo.prototype.setUserid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 ExtNumber = 4;
 * @return {number}
 */
proto.xcommon.ExtenInfo.prototype.getExtnumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ExtenInfo} returns this
 */
proto.xcommon.ExtenInfo.prototype.setExtnumber = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 AssignStatus = 6;
 * @return {number}
 */
proto.xcommon.ExtenInfo.prototype.getAssignstatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ExtenInfo} returns this
 */
proto.xcommon.ExtenInfo.prototype.setAssignstatus = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string SupteleName = 7;
 * @return {string}
 */
proto.xcommon.ExtenInfo.prototype.getSuptelename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ExtenInfo} returns this
 */
proto.xcommon.ExtenInfo.prototype.setSuptelename = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 Supplier = 8;
 * @return {number}
 */
proto.xcommon.ExtenInfo.prototype.getSupplier = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ExtenInfo} returns this
 */
proto.xcommon.ExtenInfo.prototype.setSupplier = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 Ctime = 9;
 * @return {number}
 */
proto.xcommon.ExtenInfo.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ExtenInfo} returns this
 */
proto.xcommon.ExtenInfo.prototype.setCtime = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 Utime = 10;
 * @return {number}
 */
proto.xcommon.ExtenInfo.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ExtenInfo} returns this
 */
proto.xcommon.ExtenInfo.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string VOIPName = 11;
 * @return {string}
 */
proto.xcommon.ExtenInfo.prototype.getVoipname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ExtenInfo} returns this
 */
proto.xcommon.ExtenInfo.prototype.setVoipname = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string ExtUser = 12;
 * @return {string}
 */
proto.xcommon.ExtenInfo.prototype.getExtuser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ExtenInfo} returns this
 */
proto.xcommon.ExtenInfo.prototype.setExtuser = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string ExtPwd = 13;
 * @return {string}
 */
proto.xcommon.ExtenInfo.prototype.getExtpwd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ExtenInfo} returns this
 */
proto.xcommon.ExtenInfo.prototype.setExtpwd = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional int64 NxteleId = 14;
 * @return {number}
 */
proto.xcommon.ExtenInfo.prototype.getNxteleid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ExtenInfo} returns this
 */
proto.xcommon.ExtenInfo.prototype.setNxteleid = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.NxteleListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.NxteleListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.NxteleListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.NxteleListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    appkey: jspb.Message.getFieldWithDefault(msg, 4, ""),
    secretkey: jspb.Message.getFieldWithDefault(msg, 5, ""),
    belong: jspb.Message.getFieldWithDefault(msg, 6, 0),
    systemtype: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.NxteleListReq}
 */
proto.xcommon.NxteleListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.NxteleListReq;
  return proto.xcommon.NxteleListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.NxteleListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.NxteleListReq}
 */
proto.xcommon.NxteleListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppkey(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecretkey(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBelong(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSystemtype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.NxteleListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.NxteleListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.NxteleListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.NxteleListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAppkey();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSecretkey();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBelong();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getSystemtype();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.NxteleListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.NxteleListReq} returns this
*/
proto.xcommon.NxteleListReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.NxteleListReq} returns this
 */
proto.xcommon.NxteleListReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.NxteleListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.NxteleListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.xcommon.NxteleListReq} returns this
*/
proto.xcommon.NxteleListReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.NxteleListReq} returns this
 */
proto.xcommon.NxteleListReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.NxteleListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string Name = 3;
 * @return {string}
 */
proto.xcommon.NxteleListReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.NxteleListReq} returns this
 */
proto.xcommon.NxteleListReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string AppKey = 4;
 * @return {string}
 */
proto.xcommon.NxteleListReq.prototype.getAppkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.NxteleListReq} returns this
 */
proto.xcommon.NxteleListReq.prototype.setAppkey = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string SecretKey = 5;
 * @return {string}
 */
proto.xcommon.NxteleListReq.prototype.getSecretkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.NxteleListReq} returns this
 */
proto.xcommon.NxteleListReq.prototype.setSecretkey = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 Belong = 6;
 * @return {number}
 */
proto.xcommon.NxteleListReq.prototype.getBelong = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.NxteleListReq} returns this
 */
proto.xcommon.NxteleListReq.prototype.setBelong = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string SystemType = 7;
 * @return {string}
 */
proto.xcommon.NxteleListReq.prototype.getSystemtype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.NxteleListReq} returns this
 */
proto.xcommon.NxteleListReq.prototype.setSystemtype = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.NxteleInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.NxteleInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.NxteleInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.NxteleInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    appkey: jspb.Message.getFieldWithDefault(msg, 3, ""),
    secretkey: jspb.Message.getFieldWithDefault(msg, 4, ""),
    ctime: jspb.Message.getFieldWithDefault(msg, 5, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 6, 0),
    belong: jspb.Message.getFieldWithDefault(msg, 7, 0),
    belongstr: jspb.Message.getFieldWithDefault(msg, 8, ""),
    salt: jspb.Message.getFieldWithDefault(msg, 9, ""),
    companycode: jspb.Message.getFieldWithDefault(msg, 10, ""),
    systemtype: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.NxteleInfo}
 */
proto.xcommon.NxteleInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.NxteleInfo;
  return proto.xcommon.NxteleInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.NxteleInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.NxteleInfo}
 */
proto.xcommon.NxteleInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppkey(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecretkey(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBelong(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setBelongstr(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSalt(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanycode(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setSystemtype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.NxteleInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.NxteleInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.NxteleInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.NxteleInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAppkey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSecretkey();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getBelong();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getBelongstr();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSalt();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCompanycode();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getSystemtype();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.NxteleInfo.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.NxteleInfo} returns this
 */
proto.xcommon.NxteleInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.xcommon.NxteleInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.NxteleInfo} returns this
 */
proto.xcommon.NxteleInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string AppKey = 3;
 * @return {string}
 */
proto.xcommon.NxteleInfo.prototype.getAppkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.NxteleInfo} returns this
 */
proto.xcommon.NxteleInfo.prototype.setAppkey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string SecretKey = 4;
 * @return {string}
 */
proto.xcommon.NxteleInfo.prototype.getSecretkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.NxteleInfo} returns this
 */
proto.xcommon.NxteleInfo.prototype.setSecretkey = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 Ctime = 5;
 * @return {number}
 */
proto.xcommon.NxteleInfo.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.NxteleInfo} returns this
 */
proto.xcommon.NxteleInfo.prototype.setCtime = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 Utime = 6;
 * @return {number}
 */
proto.xcommon.NxteleInfo.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.NxteleInfo} returns this
 */
proto.xcommon.NxteleInfo.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 Belong = 7;
 * @return {number}
 */
proto.xcommon.NxteleInfo.prototype.getBelong = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.NxteleInfo} returns this
 */
proto.xcommon.NxteleInfo.prototype.setBelong = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string BelongStr = 8;
 * @return {string}
 */
proto.xcommon.NxteleInfo.prototype.getBelongstr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.NxteleInfo} returns this
 */
proto.xcommon.NxteleInfo.prototype.setBelongstr = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string Salt = 9;
 * @return {string}
 */
proto.xcommon.NxteleInfo.prototype.getSalt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.NxteleInfo} returns this
 */
proto.xcommon.NxteleInfo.prototype.setSalt = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string CompanyCode = 10;
 * @return {string}
 */
proto.xcommon.NxteleInfo.prototype.getCompanycode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.NxteleInfo} returns this
 */
proto.xcommon.NxteleInfo.prototype.setCompanycode = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string SystemType = 11;
 * @return {string}
 */
proto.xcommon.NxteleInfo.prototype.getSystemtype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.NxteleInfo} returns this
 */
proto.xcommon.NxteleInfo.prototype.setSystemtype = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.NxteleListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.NxteleListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.NxteleListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.NxteleListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.NxteleListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    nxtelelistList: jspb.Message.toObjectList(msg.getNxtelelistList(),
    proto.xcommon.NxteleInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.NxteleListResp}
 */
proto.xcommon.NxteleListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.NxteleListResp;
  return proto.xcommon.NxteleListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.NxteleListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.NxteleListResp}
 */
proto.xcommon.NxteleListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.NxteleInfo;
      reader.readMessage(value,proto.xcommon.NxteleInfo.deserializeBinaryFromReader);
      msg.addNxtelelist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.NxteleListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.NxteleListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.NxteleListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.NxteleListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getNxtelelistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.NxteleInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.NxteleListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.NxteleListResp} returns this
*/
proto.xcommon.NxteleListResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.NxteleListResp} returns this
 */
proto.xcommon.NxteleListResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.NxteleListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.NxteleListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/**
 * @param {?proto.xcommon.PageOut|undefined} value
 * @return {!proto.xcommon.NxteleListResp} returns this
*/
proto.xcommon.NxteleListResp.prototype.setPageout = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.NxteleListResp} returns this
 */
proto.xcommon.NxteleListResp.prototype.clearPageout = function() {
  return this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.NxteleListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated NxteleInfo NxteleList = 3;
 * @return {!Array<!proto.xcommon.NxteleInfo>}
 */
proto.xcommon.NxteleListResp.prototype.getNxtelelistList = function() {
  return /** @type{!Array<!proto.xcommon.NxteleInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.NxteleInfo, 3));
};


/**
 * @param {!Array<!proto.xcommon.NxteleInfo>} value
 * @return {!proto.xcommon.NxteleListResp} returns this
*/
proto.xcommon.NxteleListResp.prototype.setNxtelelistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.NxteleInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.NxteleInfo}
 */
proto.xcommon.NxteleListResp.prototype.addNxtelelist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.NxteleInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.NxteleListResp} returns this
 */
proto.xcommon.NxteleListResp.prototype.clearNxtelelistList = function() {
  return this.setNxtelelistList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OperateNxteleReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OperateNxteleReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OperateNxteleReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OperateNxteleReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    operate: jspb.Message.getFieldWithDefault(msg, 2, 0),
    id: jspb.Message.getFieldWithDefault(msg, 3, 0),
    name: jspb.Message.getFieldWithDefault(msg, 4, ""),
    appkey: jspb.Message.getFieldWithDefault(msg, 5, ""),
    secretkey: jspb.Message.getFieldWithDefault(msg, 6, ""),
    belong: jspb.Message.getFieldWithDefault(msg, 7, 0),
    salt: jspb.Message.getFieldWithDefault(msg, 8, ""),
    companycode: jspb.Message.getFieldWithDefault(msg, 9, ""),
    systemtype: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OperateNxteleReq}
 */
proto.xcommon.OperateNxteleReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OperateNxteleReq;
  return proto.xcommon.OperateNxteleReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OperateNxteleReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OperateNxteleReq}
 */
proto.xcommon.OperateNxteleReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.Operate} */ (reader.readEnum());
      msg.setOperate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppkey(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecretkey(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBelong(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSalt(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanycode(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSystemtype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OperateNxteleReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OperateNxteleReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OperateNxteleReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OperateNxteleReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOperate();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAppkey();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSecretkey();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBelong();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getSalt();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCompanycode();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSystemtype();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.OperateNxteleReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.OperateNxteleReq} returns this
*/
proto.xcommon.OperateNxteleReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.OperateNxteleReq} returns this
 */
proto.xcommon.OperateNxteleReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.OperateNxteleReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Operate Operate = 2;
 * @return {!proto.xcommon.Operate}
 */
proto.xcommon.OperateNxteleReq.prototype.getOperate = function() {
  return /** @type {!proto.xcommon.Operate} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.xcommon.Operate} value
 * @return {!proto.xcommon.OperateNxteleReq} returns this
 */
proto.xcommon.OperateNxteleReq.prototype.setOperate = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int64 ID = 3;
 * @return {number}
 */
proto.xcommon.OperateNxteleReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OperateNxteleReq} returns this
 */
proto.xcommon.OperateNxteleReq.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string Name = 4;
 * @return {string}
 */
proto.xcommon.OperateNxteleReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.OperateNxteleReq} returns this
 */
proto.xcommon.OperateNxteleReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string AppKey = 5;
 * @return {string}
 */
proto.xcommon.OperateNxteleReq.prototype.getAppkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.OperateNxteleReq} returns this
 */
proto.xcommon.OperateNxteleReq.prototype.setAppkey = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string SecretKey = 6;
 * @return {string}
 */
proto.xcommon.OperateNxteleReq.prototype.getSecretkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.OperateNxteleReq} returns this
 */
proto.xcommon.OperateNxteleReq.prototype.setSecretkey = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 Belong = 7;
 * @return {number}
 */
proto.xcommon.OperateNxteleReq.prototype.getBelong = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OperateNxteleReq} returns this
 */
proto.xcommon.OperateNxteleReq.prototype.setBelong = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string Salt = 8;
 * @return {string}
 */
proto.xcommon.OperateNxteleReq.prototype.getSalt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.OperateNxteleReq} returns this
 */
proto.xcommon.OperateNxteleReq.prototype.setSalt = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string CompanyCode = 9;
 * @return {string}
 */
proto.xcommon.OperateNxteleReq.prototype.getCompanycode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.OperateNxteleReq} returns this
 */
proto.xcommon.OperateNxteleReq.prototype.setCompanycode = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string SystemType = 10;
 * @return {string}
 */
proto.xcommon.OperateNxteleReq.prototype.getSystemtype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.OperateNxteleReq} returns this
 */
proto.xcommon.OperateNxteleReq.prototype.setSystemtype = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OperateNxteleResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OperateNxteleResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OperateNxteleResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OperateNxteleResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OperateNxteleResp}
 */
proto.xcommon.OperateNxteleResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OperateNxteleResp;
  return proto.xcommon.OperateNxteleResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OperateNxteleResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OperateNxteleResp}
 */
proto.xcommon.OperateNxteleResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OperateNxteleResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OperateNxteleResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OperateNxteleResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OperateNxteleResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.OperateNxteleResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.OperateNxteleResp} returns this
*/
proto.xcommon.OperateNxteleResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.OperateNxteleResp} returns this
 */
proto.xcommon.OperateNxteleResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.OperateNxteleResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.OperateExtenPhoneReq.repeatedFields_ = [12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OperateExtenPhoneReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OperateExtenPhoneReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OperateExtenPhoneReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OperateExtenPhoneReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    operate: jspb.Message.getFieldWithDefault(msg, 2, 0),
    id: jspb.Message.getFieldWithDefault(msg, 3, 0),
    supliertype: jspb.Message.getFieldWithDefault(msg, 4, 0),
    nxteleid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    assignid: jspb.Message.getFieldWithDefault(msg, 6, 0),
    extnumberstart: jspb.Message.getFieldWithDefault(msg, 7, 0),
    extnumberend: jspb.Message.getFieldWithDefault(msg, 8, 0),
    assignstatus: jspb.Message.getFieldWithDefault(msg, 9, 0),
    extnumber: jspb.Message.getFieldWithDefault(msg, 10, 0),
    opuid: jspb.Message.getFieldWithDefault(msg, 11, 0),
    idsList: (f = jspb.Message.getRepeatedField(msg, 12)) == null ? undefined : f,
    extuser: jspb.Message.getFieldWithDefault(msg, 13, ""),
    extpwd: jspb.Message.getFieldWithDefault(msg, 14, ""),
    extuserstart: jspb.Message.getFieldWithDefault(msg, 15, 0),
    extuserend: jspb.Message.getFieldWithDefault(msg, 16, 0),
    extpwdstart: jspb.Message.getFieldWithDefault(msg, 17, 0),
    extpwdend: jspb.Message.getFieldWithDefault(msg, 18, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OperateExtenPhoneReq}
 */
proto.xcommon.OperateExtenPhoneReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OperateExtenPhoneReq;
  return proto.xcommon.OperateExtenPhoneReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OperateExtenPhoneReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OperateExtenPhoneReq}
 */
proto.xcommon.OperateExtenPhoneReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.Operate} */ (reader.readEnum());
      msg.setOperate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSupliertype(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNxteleid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignid(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExtnumberstart(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExtnumberend(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignstatus(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExtnumber(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpuid(value);
      break;
    case 12:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addIds(values[i]);
      }
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtuser(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtpwd(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExtuserstart(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExtuserend(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExtpwdstart(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExtpwdend(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OperateExtenPhoneReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OperateExtenPhoneReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OperateExtenPhoneReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OperateExtenPhoneReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOperate();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getSupliertype();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getNxteleid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getAssignid();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getExtnumberstart();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getExtnumberend();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getAssignstatus();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getExtnumber();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getOpuid();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      12,
      f
    );
  }
  f = message.getExtuser();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getExtpwd();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getExtuserstart();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getExtuserend();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getExtpwdstart();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
  f = message.getExtpwdend();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.OperateExtenPhoneReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.OperateExtenPhoneReq} returns this
*/
proto.xcommon.OperateExtenPhoneReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.OperateExtenPhoneReq} returns this
 */
proto.xcommon.OperateExtenPhoneReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.OperateExtenPhoneReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Operate Operate = 2;
 * @return {!proto.xcommon.Operate}
 */
proto.xcommon.OperateExtenPhoneReq.prototype.getOperate = function() {
  return /** @type {!proto.xcommon.Operate} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.xcommon.Operate} value
 * @return {!proto.xcommon.OperateExtenPhoneReq} returns this
 */
proto.xcommon.OperateExtenPhoneReq.prototype.setOperate = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int64 Id = 3;
 * @return {number}
 */
proto.xcommon.OperateExtenPhoneReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OperateExtenPhoneReq} returns this
 */
proto.xcommon.OperateExtenPhoneReq.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 SuplierType = 4;
 * @return {number}
 */
proto.xcommon.OperateExtenPhoneReq.prototype.getSupliertype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OperateExtenPhoneReq} returns this
 */
proto.xcommon.OperateExtenPhoneReq.prototype.setSupliertype = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 NxteleId = 5;
 * @return {number}
 */
proto.xcommon.OperateExtenPhoneReq.prototype.getNxteleid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OperateExtenPhoneReq} returns this
 */
proto.xcommon.OperateExtenPhoneReq.prototype.setNxteleid = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 AssignId = 6;
 * @return {number}
 */
proto.xcommon.OperateExtenPhoneReq.prototype.getAssignid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OperateExtenPhoneReq} returns this
 */
proto.xcommon.OperateExtenPhoneReq.prototype.setAssignid = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 ExtNumberStart = 7;
 * @return {number}
 */
proto.xcommon.OperateExtenPhoneReq.prototype.getExtnumberstart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OperateExtenPhoneReq} returns this
 */
proto.xcommon.OperateExtenPhoneReq.prototype.setExtnumberstart = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 ExtNumberEnd = 8;
 * @return {number}
 */
proto.xcommon.OperateExtenPhoneReq.prototype.getExtnumberend = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OperateExtenPhoneReq} returns this
 */
proto.xcommon.OperateExtenPhoneReq.prototype.setExtnumberend = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 AssignStatus = 9;
 * @return {number}
 */
proto.xcommon.OperateExtenPhoneReq.prototype.getAssignstatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OperateExtenPhoneReq} returns this
 */
proto.xcommon.OperateExtenPhoneReq.prototype.setAssignstatus = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 ExtNumber = 10;
 * @return {number}
 */
proto.xcommon.OperateExtenPhoneReq.prototype.getExtnumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OperateExtenPhoneReq} returns this
 */
proto.xcommon.OperateExtenPhoneReq.prototype.setExtnumber = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 OpUid = 11;
 * @return {number}
 */
proto.xcommon.OperateExtenPhoneReq.prototype.getOpuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OperateExtenPhoneReq} returns this
 */
proto.xcommon.OperateExtenPhoneReq.prototype.setOpuid = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * repeated int64 Ids = 12;
 * @return {!Array<number>}
 */
proto.xcommon.OperateExtenPhoneReq.prototype.getIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 12));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.xcommon.OperateExtenPhoneReq} returns this
 */
proto.xcommon.OperateExtenPhoneReq.prototype.setIdsList = function(value) {
  return jspb.Message.setField(this, 12, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.xcommon.OperateExtenPhoneReq} returns this
 */
proto.xcommon.OperateExtenPhoneReq.prototype.addIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 12, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.OperateExtenPhoneReq} returns this
 */
proto.xcommon.OperateExtenPhoneReq.prototype.clearIdsList = function() {
  return this.setIdsList([]);
};


/**
 * optional string ExtUser = 13;
 * @return {string}
 */
proto.xcommon.OperateExtenPhoneReq.prototype.getExtuser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.OperateExtenPhoneReq} returns this
 */
proto.xcommon.OperateExtenPhoneReq.prototype.setExtuser = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string ExtPwd = 14;
 * @return {string}
 */
proto.xcommon.OperateExtenPhoneReq.prototype.getExtpwd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.OperateExtenPhoneReq} returns this
 */
proto.xcommon.OperateExtenPhoneReq.prototype.setExtpwd = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional int64 ExtUserStart = 15;
 * @return {number}
 */
proto.xcommon.OperateExtenPhoneReq.prototype.getExtuserstart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OperateExtenPhoneReq} returns this
 */
proto.xcommon.OperateExtenPhoneReq.prototype.setExtuserstart = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int64 ExtUserEnd = 16;
 * @return {number}
 */
proto.xcommon.OperateExtenPhoneReq.prototype.getExtuserend = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OperateExtenPhoneReq} returns this
 */
proto.xcommon.OperateExtenPhoneReq.prototype.setExtuserend = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int64 ExtPwdStart = 17;
 * @return {number}
 */
proto.xcommon.OperateExtenPhoneReq.prototype.getExtpwdstart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OperateExtenPhoneReq} returns this
 */
proto.xcommon.OperateExtenPhoneReq.prototype.setExtpwdstart = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int64 ExtPwdEnd = 18;
 * @return {number}
 */
proto.xcommon.OperateExtenPhoneReq.prototype.getExtpwdend = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OperateExtenPhoneReq} returns this
 */
proto.xcommon.OperateExtenPhoneReq.prototype.setExtpwdend = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


module.exports = proto.xcommon;
